const TERM_REWRITES = new Map([
  ['relakas', 'nurklihvmasin'],
  ['relaka', 'nurklihvmasin'],
  ['relakat', 'nurklihvmasin'],
  ['relakale', 'nurklihvmasin'],
  ['relakaga', 'nurklihvmasin'],
  ['survekas', 'survepesur'],
  ['surveka', 'survepesur'],
  ['survekat', 'survepesur'],
  ['sabersaag', 'tiigersaag'],
  ['sabersae', 'tiigersaag'],
  ['sabersaagi', 'tiigersaag'],
  ['poldikeeraja', 'löökmutrikeeraja'],
  ['poldikeerajat', 'löökmutrikeeraja'],
  ['poldikeerajaid', 'löökmutrikeeraja'],
]);

const CATEGORY_RULES = [
  { terms: ['keevitus', 'keevituse', 'keevitusaparaat', 'keevitusmasin', 'inverterkeevitus'], tag: 'ok-nav-v1--tools-equipment--welding-equipment' },
  { terms: ['nurklihvija', 'nurklihvmasin'], tag: 'ok-nav-v1--tools-equipment--grinders-polishers' },
  { terms: ['tolmuimeja', 'tolmuimejad'], tag: 'ok-nav-v1--home-household--cleaning-vacuums' },
  { terms: ['kompressor', 'kompressorid'], tag: 'ok-nav-v1--tools-equipment--compressors-pneumatic-tools' },
  { terms: ['generaator', 'generaatorid', 'elektrigeneraator'], tag: 'ok-nav-v1--tools-equipment--generators-power-equipment' },
  { terms: ['tungraud', 'tungrauad', 'tungraua'], tag: 'ok-nav-v1--automotive-garage--jacks-lifts' },
  { terms: ['kettsaag', 'kettsaed', 'kettsae', 'mootorsaag'], tag: 'ok-nav-v1--garden-forestry--chainsaws' },
  { terms: ['survepesur', 'survepesurid', 'kõrgsurvepesur', 'kõrgsurvepesurid'], tag: 'ok-nav-v1--home-household--pressure-washers' },
  { terms: ['akutrell', 'akutrellid', 'akutrelli'], tag: 'ok-nav-v1--tools-equipment--cordless-tools' },
  { terms: ['trell', 'trellid', 'trelli', 'löökpuur', 'puurvasar'], tag: 'ok-nav-v1--tools-equipment--drills-drivers-hammers' },
  { terms: ['mutrikeeraja', 'mutrikeerajad', 'mutrikeerajat', 'löökmutrikeeraja', 'akulöökmutrikeeraja'], tag: 'ok-nav-v1--tools-equipment--impact-wrenches' },
  { terms: ['tiigersaag', 'ketassaag', 'tikksaag'], tag: 'ok-nav-v1--tools-equipment--saws-cutting-machines' },
  { terms: ['muruniiduk', 'muruniidukid'], tag: 'ok-nav-v1--garden-forestry--lawn-mowers' },
  { terms: ['trimmer', 'trimmerid', 'võsalõikur', 'võsalõikurid'], tag: 'ok-nav-v1--garden-forestry--trimmers-brushcutters' },
  { terms: ['mullafrees', 'kultivaator', 'kultivaatorid'], tag: 'ok-nav-v1--garden-forestry--tillers-cultivators' },
  { terms: ['lehepuhur', 'lehepuhurid'], tag: 'ok-nav-v1--garden-forestry--garden-blowers' },
  { terms: ['oksapurustaja', 'oksapurustajad'], tag: 'ok-nav-v1--garden-forestry--branch-shredders' },
  { terms: ['aiapump', 'veepump', 'veepumbad'], tag: 'ok-nav-v1--garden-forestry--garden-pumps-watering' },
  { terms: ['elektrimootor', 'elektrimootorid'], tag: 'ok-nav-v1--tools-equipment--electric-motors' },
  { terms: ['jootekolb', 'kuumapuhur'], tag: 'ok-nav-v1--tools-equipment--soldering-heat-tools' },
  { terms: ['ülafrees', 'höövel', 'höövlid'], tag: 'ok-nav-v1--tools-equipment--routers-planers-woodworking' },
  { terms: ['vibroplaat', 'pinnasetihendaja'], tag: 'ok-nav-v1--tools-equipment--compactors' },
  { terms: ['laserlood', 'laserkaugusmõõtja'], tag: 'ok-nav-v1--tools-equipment--measuring-laser-tools' },
  { terms: ['redel', 'redelid'], tag: 'ok-nav-v1--construction-renovation--ladders' },
  { terms: ['tööriistakäru', 'tööriistakapp'], tag: 'ok-nav-v1--tools-equipment--workshop-storage' },
  { terms: ['töökindad', 'töökinnas'], tag: 'ok-nav-v1--workwear-safety--work-gloves' },
  { terms: ['tööjalatsid', 'töösaapad', 'turvajalatsid'], tag: 'ok-nav-v1--workwear-safety--work-shoes' },
];

const ACCESSORY_INTENT_TERMS = new Set([
  'adapter', 'adapterid', 'alus', 'harjad', 'hammasratas', 'hoidik', 'juhe',
  'kaabel', 'kaitse', 'kate', 'ketas', 'kiiver', 'korpus', 'laadija', 'laager', 'latt', 'lüliti',
  'mask', 'mootor', 'osa', 'osad', 'otsik', 'otsikud', 'padrun', 'plaat', 'rihm', 'rootor',
  'staator', 'tarvik', 'tarvikud', 'tera', 'terad', 'filter', 'filtrid', 'varuosa', 'varuosad',
  'voolik', 'võti', 'kett',
]);

const TYPO_REWRITES = new Map([
  ...CATEGORY_RULES.flatMap((rule) => rule.terms.map((term) => [term, term])),
  ...TERM_REWRITES,
]);

const STRUCTURED_QUERY_PATTERN = /(?:\b(?:id|sku|tag|vendor|product_type):|\bOR\b)/i;
const MODEL_CODE_PATTERN = /(?=.*[a-zõäöü])(?=.*\d)[a-zõäöü0-9-]{4,}/i;

function normalizeKey(value) {
  return value
    .normalize('NFKC')
    .toLocaleLowerCase('et')
    .replace(/[“”„"']/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function editDistance(left, right) {
  if (left === right) return 0;
  if (Math.abs(left.length - right.length) > 1) return 2;

  let previous = Array.from({ length: right.length + 1 }, (_, index) => index);

  for (let leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
    const current = [leftIndex];

    for (let rightIndex = 1; rightIndex <= right.length; rightIndex += 1) {
      const substitutionCost = left[leftIndex - 1] === right[rightIndex - 1] ? 0 : 1;
      current[rightIndex] = Math.min(
        current[rightIndex - 1] + 1,
        previous[rightIndex] + 1,
        previous[rightIndex - 1] + substitutionCost
      );
    }

    previous = current;
  }

  return previous[right.length];
}

function findTypoRewrite(key) {
  if (TYPO_REWRITES.has(key)) return null;

  if (key.includes(' ') || key.length < 6 || !/^[a-zõäöüšž-]+$/i.test(key)) {
    return null;
  }

  let matchedRewrite = null;

  for (const [candidate, rewrite] of TYPO_REWRITES) {
    if (candidate.includes(' ') || Math.abs(candidate.length - key.length) > 1) continue;
    if (editDistance(candidate, key) !== 1) continue;
    if (matchedRewrite) return null;
    matchedRewrite = rewrite;
  }

  return matchedRewrite;
}

function replaceKnownTerms(key) {
  let result = key;
  const rewrites = [...TERM_REWRITES].sort((first, second) => second[0].length - first[0].length);

  for (const [source, target] of rewrites) {
    const escapedSource = source.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    result = result.replace(new RegExp(`(^|\\s)${escapedSource}(?=\\s|$)`, 'gu'), `$1${target}`);
  }

  return result;
}

function includesTerm(query, term) {
  return query === term || query.startsWith(`${term} `) || query.endsWith(` ${term}`) || query.includes(` ${term} `);
}

function hasAccessoryIntent(query) {
  return query.split(/\s+/u).some((term) => ACCESSORY_INTENT_TERMS.has(term));
}

function findCategoryTag(query) {
  if (hasAccessoryIntent(query)) return null;

  const matches = CATEGORY_RULES.filter((rule) => rule.terms.some((term) => includesTerm(query, term)));
  const tags = [...new Set(matches.map((rule) => rule.tag))];
  return tags.length === 1 ? tags[0] : null;
}

export function prepareSearchQuery(value) {
  const original = String(value || '').replace(/\s+/g, ' ').trim();

  if (!original || STRUCTURED_QUERY_PATTERN.test(original) || MODEL_CODE_PATTERN.test(original)) {
    return { original, query: original, rewritten: false };
  }

  const key = normalizeKey(original);
  const replaced = replaceKnownTerms(key);
  const typoRewrite = replaced === key ? findTypoRewrite(key) : null;
  const searchableQuery = typoRewrite || (replaced !== key ? replaced : original);
  const categoryTag = findCategoryTag(normalizeKey(searchableQuery));
  const query = categoryTag ? `${searchableQuery} tag:${categoryTag}` : searchableQuery;
  return { original, query, rewritten: query !== original };
}

export function originalSearchQuery(url = new URL(window.location.href)) {
  return (url.searchParams.get('oq') || url.searchParams.get('q') || '').trim();
}

if (typeof window !== 'undefined') {
  window.OstuklikkSearchQuery = Object.freeze({ originalSearchQuery, prepareSearchQuery });
}
